import { DownloadOutlined, UploadOutlined } from '@ant-design/icons'
import { Button, Form, Upload } from 'antd'
import { useState } from 'react'
import ModalCustom from '../common/Modal/ModalCustom'
import openNotification from '../common/Notification/openNotification '
import { projectImportExcel } from '../../services/projectservice'
const customizeRequiredMark = (label, { required }) => (
  <>
    {label}
    {required && <span style={{ color: 'red' }}> *</span>}
  </>
)

const FormAddExcel = ({
  isModalOpen,
  setIsModalOpen,
  fetchApiList
}) => {
  const [form] = Form.useForm()
  const [excelfileList, setExcelfileList] = useState([])

  const handleImport = async () => {
    const values = await form.validateFields()
    const formData = new FormData();
    formData.append("excel", values.files.file);

    try {
      const res = await projectImportExcel(formData)
      setIsModalOpen(false)
      setExcelfileList([])
      fetchApiList()
      openNotification('success', 'Tạo post thành công')
    } catch (err) {
      openNotification('error', err?.response?.data?.message || 'Đã có lỗi xảy ra')
    }
  }
  const handleChangeFileExcel = ({ fileList }) => {
    setExcelfileList(fileList)
  }

  const handlePreview = (file) => {
    // Tạo URL tạm thời để download file
    const url = URL.createObjectURL(file.originFileObj);
    const a = document.createElement("a");
    a.href = url;
    a.download = file.name || "download.xlsx"; // Tên file khi tải về
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url); // Giải phóng bộ nhớ
  };
  
  return (
    <ModalCustom
      title="Import file"
      visible={isModalOpen}
      centered
      width={600}
      // className="modal-bond"
      onCancel={() => {
        setIsModalOpen(false)
        form.resetFields()
        // setProdudctImport([])
        setExcelfileList([])
        //   setFileList([])
      }}
      onConfirm={async () => {
        try {
          await form.validateFields() // Kiểm tra validation trước khi tiếp tục
          handleImport() // Nếu hợp lệ thì tiếp tục xử lý
        } catch (error) {
          console.log('Validation failed:', error)
        }
      }}
      confirmText={'Lưu'}
      cancelText="Đóng"
    >
      {/* <Modal
        title={'Import file'}
        visible={createModalImportVisible}
        okText={'Lưu'}
        cancelText={'Huỷ bỏ'}
        width={600}
        onCancel={() => {
          handleModalImportVisible(false);
          formImport.resetFields();
          setProdudctImport('');
        }}
        onOk={formImport.submit} */}

      <Form
        layout="horizontal"
        form={form}
        name="basic"
        labelCol={{ span: 8 }}
        // wrapperCol={{ span: 18 }}
        style={{
          marginTop: 10,
          overflow: 'auto',
          overflowX: 'hidden',
          padding: '0px 10px'
        }}
        labelAlign="left"
        onFinish={(value) => handleImport(value)}
        requiredMark={customizeRequiredMark}
>

        <Form.Item label="Upload file" name="files">
          <Upload
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            fileList={excelfileList}
            onChange={handleChangeFileExcel}
            beforeUpload={() => false}
            onPreview={handlePreview}
            itemRender={(originNode, file) => (
              <a
                style={{ cursor: "pointer", textDecoration: "underline" }}
              >
                {originNode}
              </a>
            )}
          >
            {excelfileList?.length <= 0 && (
              <Button icon={<UploadOutlined />}>Upload</Button>
            )}
          </Upload>
        </Form.Item>
        <Form.Item label="Template thư viện dự án" name="files">
                <a href="/template/file_project_management.xlsx">
                  <DownloadOutlined /> file_example.xlsx
                </a>
              </Form.Item>
      </Form>
    </ModalCustom>
  )
}

export default FormAddExcel
